import './index.scss';

const LoadingBar = (props) => {
    return (
        <div class="progress-bar"></div>
    )  
}

export default LoadingBar;